import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight, ArrowLeft, Check } from 'lucide-react';
import { caseStudies } from './caseStudiesData';
import './CaseStudyDetail.css';

export const CaseStudyDetail = () => {
  const { slug } = useParams();
  const reduced = useReducedMotion();
  const c = caseStudies[slug];

  if (!c) return <Navigate to="/case-studies" replace />;

  const fade = {
    hidden: { opacity: 0, y: reduced ? 0 : 18 },
    visible: (i = 0) => ({
      opacity: 1, y: 0,
      transition: { duration: reduced ? 0.2 : 0.55, delay: reduced ? 0 : i * 0.06, ease: [0.16, 1, 0.3, 1] },
    }),
  };

  return (
    <div className="csd-page">
      <section className="csd-hero">
        <div className="csd-hero-glow" aria-hidden="true" />
        <Link to="/case-studies" className="csd-back"><ArrowLeft size={15} /> All case studies</Link>
        <motion.div className="csd-tags" initial="hidden" animate="visible" variants={fade}>
          <span className="csd-tag industry">{c.industry}</span>
          <span className="csd-tag type">{c.type}</span>
        </motion.div>
        <motion.h1 className="csd-title" initial="hidden" animate="visible" variants={fade} custom={1}>
          {c.title}
        </motion.h1>
        <motion.p className="csd-summary" initial="hidden" animate="visible" variants={fade} custom={2}>
          {c.summary}
        </motion.p>
      </section>

      <section className="csd-body">
        <div className="csd-block">
          <h2>The problem</h2>
          <p>{c.problem}</p>
        </div>
        <div className="csd-block">
          <h2>What we built</h2>
          <p>{c.built}</p>
        </div>
        <div className="csd-block">
          <h2>The results</h2>
          <ul className="csd-results">
            {c.results.map((r) => <li key={r}><Check size={16} /> {r}</li>)}
          </ul>
        </div>
        <div className="csd-block">
          <h2>Tech stack</h2>
          <div className="csd-stack">
            {c.stack.map((s) => <span key={s} className="csd-chip">{s}</span>)}
          </div>
        </div>
      </section>

      <section className="csd-cta">
        <div className="csd-cta-glow" aria-hidden="true" />
        <h2>Want something similar?</h2>
        <p>We start every project with a free scoping call. No commitment.</p>
        <Link to="/contact" className="btn-primary">Book a Scoping Call <ArrowRight size={18} /></Link>
      </section>
    </div>
  );
};
